import { render, staticRenderFns } from "./ClassesListModal.vue?vue&type=template&id=52c24b09&scoped=true&"
import script from "./ClassesListModal.vue?vue&type=script&lang=js&"
export * from "./ClassesListModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassesListModal.vue?vue&type=style&index=0&id=52c24b09&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c24b09",
  null
  
)

export default component.exports